var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/griddle-react/~/lodash/_Symbol.js
// module id = 286
// module chunks = 4